import { render, staticRenderFns } from "./StatsRow.vue?vue&type=template&id=01a8bee6&"
import script from "./StatsRow.vue?vue&type=script&lang=js&"
export * from "./StatsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports